<template>
  <Chart type="line" :data="props.chartData.data" :options="props.chartData.opts"/>
</template>

<script setup lang="ts">
import { Chart as ChartJS, registerables } from 'chart.js';
// time スケールに必要な日付アダプタ（chart.js v4 は内蔵しないため明示的に読み込む）
import 'chartjs-adapter-date-fns';
import { Chart } from 'vue-chartjs';
import type { LineChartProps } from 'src/models/chart';

// chart.js v3+ はツリーシェイク方式のため、利用するコントローラ・要素・スケール・プラグインを登録する
ChartJS.register(...registerables);

interface Props {
  chartData: LineChartProps;
}

const props = defineProps<Props>();
</script>
